import {FormDrawer} from "./FormDrawer.tsx";
import {DrawerProps} from "@mantine/core";
import {useParams} from "react-router-dom";
import {useOrder} from "../hooks/useOrder.ts";
import {Order} from "../types.ts";

export const AddFormDrawer = (props: DrawerProps) => {
    const {id: customerId} = useParams();
    if (!customerId) throw new Error('customerId is required');

    const {createRecord} = useOrder();

    return (
        <FormDrawer
            record={{
                id: '',
                customerId,
                subscriptionId: '',
            } as Order}
            handleSubmit={createRecord}
            {...props}
        />
    )
};
